const MODALS_TYPE = {
  UPGRADE_MESSAGE: 'UPGRADE_MESSAGE',
  UPLOAD_PROGRESS: 'UPLOAD_PROGRESS',
  ACTIONS_MODAL: 'ACTIONS_MODAL',
  CONFIRM_MODAL: 'CONFIRM_MODAL',
  DELETE_MODAL: 'DELETE_MODAL',
  FORM_MODAL: 'FORM_MODAL'
};

// ! Modal Generic types

export { MODALS_TYPE };
//# sourceMappingURL=types.js.map
